// メンテナンスメッセージ
import React from 'react';
import { convertLine } from '../Convert';

interface Props {
  message: string;
}

const MaintenanceMessage: React.FC<Props> = ({ message }) => {
  const replaceReturnCode = (msg?: string) => {
    if (msg === null || typeof msg === 'undefined') {
      return msg;
    }
    return <React.Fragment>{convertLine(msg)}</React.Fragment>;
  };

  return (
    <>
      {message && (
        <div>
          <span className="maintenance-message text-danger link-font-bold">
            {replaceReturnCode(message)}
          </span>
        </div>
      )}
    </>
  );
};

export default MaintenanceMessage;
